var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuppliers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Nav Icons - B"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.0008 3H3.00079C1.89622 3 1.00079 3.89543 1.00079 5V14C1.00079 15.1046 1.89622 16 3.00079 16H16.0008V5C16.0008 3.89543 15.1054 3 14.0008 3Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.0008 8.00037H19.1724C19.7028 8.00037 20.2115 8.21108 20.5866 8.58615L22.415 10.4146C22.7901 10.7897 23.0008 11.2984 23.0008 11.8288V14.0004C23.0008 15.1049 22.1054 16.0004 21.0008 16.0004H16.0008V8.00037Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.5 20.9996C6.88071 20.9996 8 19.8803 8 18.4996C8 17.1189 6.88071 15.9996 5.5 15.9996C4.11929 15.9996 3 17.1189 3 18.4996C3 19.8803 4.11929 20.9996 5.5 20.9996Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M18.5008 20.9996C19.8815 20.9996 21.0008 19.8803 21.0008 18.4996C21.0008 17.1189 19.8815 15.9996 18.5008 15.9996C17.1201 15.9996 16.0008 17.1189 16.0008 18.4996C16.0008 19.8803 17.1201 20.9996 18.5008 20.9996Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuppliers);
export default __webpack_public_path__ + "static/media/suppliers.70075a53f4a611944cbaf3d813d4cdd7.svg";
export { ForwardRef as ReactComponent };